import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { PATH } from '@app/constants';
import { Developer } from '@app/interfaces';
import { DeveloperService } from '@app/services';

@Component({
  selector: 'mnf-authentication-register-dev',
  templateUrl: './authentication-register-dev.component.html',
  styleUrls: ['./authentication-register-dev.component.scss']
})
export class AuthenticationRegisterDevComponent implements OnInit {

  user: Developer;
  regStep: number;
  userType: string = 'd' || 'u';

  step = 1;

  constructor(private router: Router, private developerServ: DeveloperService) { }

  ngOnInit(): void {
    this.getDeveloper(true);
  }

  getDeveloper(reset?: boolean) {
    this.developerServ.getDeveloper(reset).subscribe(d => {
      // Obtener etapa actual del registro
      this.regStep = d?.regStep;
      // Obtener el tipo de usuario actual
      this.userType = d?.type;

      if(this.userType === 'd') {
        this.user = d;
        if(this.regStep >= 2) {
          this.router.navigate([PATH.ROUTE_DEVELOPER]);
        } else {
          this.router.navigate([PATH.REGISTRY_DEVELOPER]);
        }

      } else {
        this.router.navigate([PATH.ROUTE_HOME]);
      }

    });
  }

  stepOne(form: { name, fatherSurname, motherSurname }) {
    this.getDeveloper(true);
    this.step = 2;
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  stepTwo() {
    this.getDeveloper(true);
    this.step = 3;
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  stepThree(form: { message }) {
    this.getDeveloper(true);
    this.step = 5;
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  stepFourth(form: { regStep: number; }) {
    this.getDeveloper(true);
    this.step = 4
    window.scrollTo({ top: 0, behavior: 'smooth'}); 
  }

  returnStep(step: number) {
    return this.step = step;
  }

}
